import * as React from 'react';
import styled from 'styled-components';

import { useConfig } from 'src/providers';

const ThemedModalBrandImage = styled.img<{ imageError: boolean, imageName: string }>`
  ${({ imageError }) => imageError && 'display: none;'}
  width: 416px;
  object-fit: cover;

  @media (max-width: 999px) {
    display: none;
  }
`;

export function ModalBrandImage() {
  const { displayName: shopName } = useConfig();
  const [imageError, setImageError] = React.useState(false);
  const imageName = shopName.replaceAll(/[^a-zA-Z0-9]/g, '').toLowerCase();

  return (
    <ThemedModalBrandImage
      className='image'
      imageError={imageError}
      imageName={imageName}
      src={`modal-brand-images/${imageName}.jpg`}
      onError={() => setImageError(true)}
    />
  );
}
